import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type OrderFulfillmentContainerLocationDetailFragment = { __typename?: 'OrderFulfillmentContainerLocation', container_id: string, container_name: string, container_type_id: number, container_type_name: string, container_type_image?: string | null, owner_till?: string | null, next_owner_id?: string | null };

export const OrderFulfillmentContainerLocationDetailFragmentDoc = gql`
    fragment OrderFulfillmentContainerLocationDetail on OrderFulfillmentContainerLocation {
  container_id
  container_name
  container_type_id
  container_type_name
  container_type_image
  owner_till
  next_owner_id
}
    `;